module.exports = "/_next/static/images/game-3-fingerprint-part-1-wrong-red-e28bb1d1225fd9d1f7baadbfae3c8dde.png";